import React, { Component } from 'react';
import { Card, CardHeader, CardTitle, CardText } from 'material-ui/Card';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import CircularProgress from 'material-ui/CircularProgress';

import GroupUsers from './GroupUsers';
import './GroupSettings.css';

import { fetchGroup, updateGroup, generateToken, sendInvitation } from '../actions/actions';

class GroupSettings extends Component {
  constructor(props) {
    super();

    this.state = {
      groupName: props.group.name,
      invitationEmails: '',
      tokenExpanded: false,
      confirmationOpen: false
    };
  }

  componentWillMount() {
    this.props.dispatch(fetchGroup());
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ groupName: nextProps.group.name });
  }

  handleExpandChange = (element, expanded) => {
    this.setState({ element: expanded });
  };

  handleToggle = (element, toggle) => {
    this.setState({ element: toggle });
  };

  handleExpand = () => {
    this.setState({ expanded: true });
  };

  handleReduce = () => {
    this.setState({ expanded: false });
  };

  handleConfirmationDialogOpen = () => {
    this.setState({ confirmationOpen: true });
  };

  handleConfirmationDialogClose = () => {
    this.setState({ confirmationOpen: false });
  };

  handleInput = (event) => {
    event.preventDefault();
    const groupName = this.groupNameInput.getValue();
    this.setState({ groupName });
  }

  updateGroup = (event) => {
    event.preventDefault();
    const data = {
      name: this.state.groupName,
    };
    this.props.dispatch(updateGroup(data));
  }

  handleTokenGeneration = (event) => {
    event.preventDefault();
    this.props.dispatch(generateToken());
  }

  handleEmails = (event) => {
    this.setState({ invitationEmails: event.target.value });
  }

  sendEmails = async (event) => {
    event.preventDefault();
    const result = await this.props.dispatch(sendInvitation(this.state.invitationEmails));

    if (result.type === "GROUP_SEND_INVITATION_SUCCESS") {
      this.setState({ invitationEmails: '', confirmationOpen: true });
    }
  }



  render() {
    const { group } = this.props;
    const { confirmationOpen } = this.state;

    const disabled = this.props.isWaiting.GROUP_UPDATE;
    const disabledToken = this.props.isWaiting.GROUP_TOKEN_REFRESH;
    const disabledSendToken = this.props.isWaiting.GROUP_SEND_INVITATION || this.state.invitationEmails.length < 5;

    const inviteLabel = this.props.isWaiting.GROUP_SEND_INVITATION ? <CircularProgress size={20} /> : 'Send invitation';

    const actions = [
      <FlatButton
        label="OK"
        primary
        onTouchTap={this.handleConfirmationDialogClose}
      />
    ];

    const tokenConfirmationDialog = (
      <Dialog title="Tokens sent" actions={actions} modal={false} open={confirmationOpen} onRequestClose={this.handleConfirmationDialogClose} autoScrollBodyContent>
        <p>Group tokens were sent!</p>
      </Dialog>
          );

    return (
      <div key="group-settings">
        <Card className="card-wide">
          <CardHeader title="Edit your group's settings" />
          <CardText>
            <form>
              <TextField className="input-long" onChange={this.handleInput} ref={(input) => { this.groupNameInput = input; }} type="text" name="name" placeholder="Group Name" value={this.state.groupName} /><br />
              <FlatButton disabled={disabled} onClick={event => this.updateGroup(event)} label="Save Changes" />
            </form>
          </CardText>
        </Card>
        <br />
        <Card className="card-wide">
          <CardHeader title="License information" />
          <CardText>
            Seats: <strong> {group.seats}</strong> ({group.users.length} used)<br /><br />
            Valid until: <strong>{group.validUntil}</strong> ({group.validPeriod})<br />
          </CardText>
        </Card>
        <br />
        <Card className="card-wide">
          <CardHeader title="Group token" />
          <CardText className="center">
            {group.token !== null && <span>Let people join this group by giving them this token
          and instructing them to go to the register page:
              <br /><br />
              <h3 className="group-token">{group.token}</h3>
              <br /><br /></span>}
            <FlatButton disabled={disabledToken} onClick={event => this.handleTokenGeneration(event)} label="Regenerate token" /><br />
          (This will invalidate the current token)
          </CardText>
          <CardTitle title="Send token by email" showExpandableButton />
          <CardText expandable>
          List the addresses you want to send the email to below. The token along with instructions how to join will be sent to them.
          Separate multiple addresses with a comma.
            <br />
            <form>
              <textarea className="send-token" value={this.state.invitationEmails} onChange={this.handleEmails} /><br />
              <FlatButton disabled={disabledSendToken} onClick={event => this.sendEmails(event)} label={inviteLabel} />
              {confirmationOpen && tokenConfirmationDialog}
            </form>
          </CardText>
        </Card>
        <br />
        <GroupUsers {...this.props} />
      </div>
    );
  }

}

export default GroupSettings;



// WEBPACK FOOTER //
// ./src/components/GroupSettings.js